var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{staticClass:"creation-comment-textarea",attrs:{"rows":"4","placeholder":_vm.$t('create_preorder.comment_ph')},domProps:{"value":_vm.value},on:{"input":function (e) { return _vm.$emit('input', e.target.value); }}})}
var staticRenderFns = []

export { render, staticRenderFns }